<template>
    <p class="text-box" v-if="entryLink">
        {{ text }}
    </p>
	<div v-else>
			<div class="text-box skeleton-text skeleton"></div>
			<div class="text-box skeleton-text skeleton"></div>
	</div>
</template>

<script>
/**
 * Component for the display of the content in an entry.
 * @displayName EntryContent
 * isCharts is only for the skeleton
 */

import { htmlInlineText } from "@/lib/export/htmlToPlainText";

export default {
    name: "EntryContent",
    props: ["entryLink"],
    computed: {
        text() {
            return htmlInlineText(
                this.entryLink.attributes.entry.attributes.text);
        },
    },
};
</script>

<style scoped>
.text-box {
    display: -webkit-box;
    /* One clamped line was too little to tell entries apart. */
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
